module.exports = ":root{--lui-sidebar-background-color:var(--lui-neutral80-color);--lui-sidebar-color:var(--lui-white);--lui-sidebar-selected-background-color:transparent;--lui-sidebar-selected-bottom:0;--lui-sidebar-size:calc(10 * var(--lui-padding))}"


//////////////////
// WEBPACK FOOTER
// ./packages/lui-sidebar/theme/lui-sidebar.global.scss
// module id = 317
// module chunks = 0 1 27